import AbsolutePane from 'presentation/components/absolute-pane/index.js';
import Image from 'presentation/components/image/index.js';

const CardBackgroundImage = props => {
    const {
        src,
        onError,
        mojitoTools: { config },
    } = props;

    return (
        <AbsolutePane class="ta-CardBackgroundImage" config={config.container}>
            <Image src={src} config={config.image} onError={onError} />
        </AbsolutePane>
    );
};

export default CardBackgroundImage;
